import React, { FC } from 'react';
import { FieldProps } from './FieldProps';
import { inputError } from '../../utils/inputError';
import { inputValue } from '../../utils/inputValue';
import { TextField } from '../TextField/TextField';

export const Occurrence: FC<FieldProps> =
    ({ formikProps }) => {
        const name = 'occurrence';
        const error = inputError(name, formikProps);
        return (
            <TextField
                name={name}
                type='number'
                label='Occurrence'
                value={inputValue(name, formikProps)}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                error={!!error}
                helperText={error || 'Enter value only if service ends before end of term'}
                margin='dense'
                fullWidth
            />
        );
    };
